/**
 * ****************************************************************************
 * @description     :   Store menu
 * @created at      :   2024/10/11
 * @created by      :   ANS376 – daonx@ans-net.co.jp
 * @package         :   Move version 2
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

// import repository from './repository';
import Calendar from '@/assets/mb-icon/calendar.png';
import Book from '@/assets/mb-icon/book.png';
import Briefcase from '@/assets/mb-icon/briefcase.png';
// import Search from '@/assets/mb-icon/search.png';
import InclinedPen from '@/assets/mb-icon/inclined-pen.png';
import Money from '@/assets/mb-icon/money.png';
import User from '@/assets/mb-icon/user.png';
import Settings from '@/assets/mb-icon/settings.png';

const dataPreviewInit = {
    listMenu: {
        APP: {
            list: [
                {
                    name: 'PTJ_Worker001',
                    to: '/PTJ_Worker001',
                    class: '',
                    icon: Calendar,
                    title: 'カレンダー'
                },
                {
                    name: 'PTJ_Worker007',
                    to: '/PTJ_Worker007',
                    class: '',
                    icon: Book,
                    title: 'スケジュール登録'
                },
                {
                    name: 'PTJ_Worker002',
                    to: '/PTJ_Worker002',
                    class: '',
                    icon: Briefcase,
                    title: '仕事情報'
                },
                // {
                //     name: 'APP_System001',
                //     to: '/',
                //     class: '',
                //     icon: Search,
                //     title: '仕事検索'
                // },
                {
                    name: 'APP_System001',
                    to: '/',
                    class: '',
                    icon: InclinedPen,
                    title: '各種申請',
                    children: {
                        class: '',
                        list: [
                            {
                                name: 'PTJ_Worker009',
                                to: '/PTJ_Worker009',
                                class: '',
                                title: 'マイナンバー申請'
                            }
                        ]
                    }
                },
                {
                    name: 'APP_System001',
                    to: '/',
                    class: '',
                    icon: Money,
                    title: '給与振込',
                    children: {
                        class: '',
                        list: [
                            {
                                name: 'PTJ_Worker018',
                                to: '/PTJ_Worker018',
                                class: '',
                                title: '振込申請'
                            },
                            {
                                name: 'PTJ_Worker019',
                                to: '/PTJ_Worker019',
                                class: '',
                                title: '振込申請利用履歴'
                            }
                        ]
                    }
                },
                {
                    name: 'APP_System001',
                    to: '/',
                    class: '',
                    icon: User,
                    title: 'スタッフ情報',
                    children: {
                        class: '',
                        list: [
                            {
                                name: 'PTJ_Worker003',
                                to: '/PTJ_Worker003',
                                class: '',
                                title: 'スタッフ登録情報'
                            },
                            {
                                name: 'PTJ_Worker010',
                                to: '/PTJ_Worker010',
                                class: '',
                                title: '振込先情報'
                            },
                            {
                                name: 'PTJ_Worker011',
                                to: '/PTJ_Worker011',
                                class: '',
                                title: 'アンケート'
                            }
                            // {
                            //     name: 'APP_System001',
                            //     to: '/',
                            //     class: '',
                            //     title: '身分証登録'
                            // }
                        ]
                    }
                },
                {
                    name: 'APP_System001',
                    to: '/',
                    class: '',
                    icon: Settings,
                    title: 'その他',
                    children: {
                        class: '',
                        list: [
                            {
                                name: 'PTJ_Worker012',
                                to: '/PTJ_Worker012',
                                class: '',
                                title: 'パスワード変更'
                            },
                            {
                                name: 'PTJ_Worker013',
                                to: '/PTJ_Worker013',
                                class: '',
                                title: '職務遵守事項'
                            },
                            {
                                name: 'APP_System001',
                                class: '',
                                staticFile: 'STCalendar202309.jpg',
                                title: '給与振込カレンダー(西日本・中日本)'
                            },
                            {
                                name: 'APP_System001',
                                class: '',
                                staticFile: 'STCalendar202309.pdf',
                                title: '給与振込カレンダー(東日本・北日本)'
                            },
                            {
                                name: 'APP_System001',
                                class: '',
                                staticFile: 'shigotono_kokoroe_0326.jpg',
                                title: '仕事の心得'
                            },
                            {
                                name: 'APP_System001',
                                to: '/PTJ_System/login',
                                class: '',
                                title: 'ログアウト'
                            }
                        ]
                    }
                }
            ]
        }
    }
};
export default {
    namespaced: true,
    state: {
        listMenu: { ...dataPreviewInit.listMenu.APP }
    },
    mutations: {
        resetDataInit(state) {
            state.data = { ...dataPreviewInit };
        },
        setListMenuLeft() {
            // state.listMenu = newData;
        }
    },
    actions: {
        async fetchMenuLeft(context, page) {
            try {
                const responseItems = await new Promise((resolve) => {
                    resolve({
                        ...dataPreviewInit.listMenu[page]
                    });
                });
                context.commit('setListMenuLeft', responseItems);
            } catch (e) {
                console.log('fetchMenuLeft: ' + e.message);
            }
        }
    }
};
